<!-- Login.svelte -->
<script>
  import { user, accessToken } from '$lib/stores/store';

  import ApiClient from '$lib/api';
  const api = new ApiClient();

  let email = '';
  let password = '';
  let error = '';
  let isLoading = false;

  async function loginLocal() {
    error = '';
    isLoading = true;

    try {
      const data = await api.post('/auth/login', { email, password }, { withCredentials: true });
      if (!data.user || !data.accessToken) {
        throw new Error('Response missing user or accessToken');
      }

      user.set(data.user);
      //accessToken.set(data.accessToken);

      console.log('login::', data);

      //console.log('setdata login:', data);
      api.setAccessToken(data.accessToken);
    } catch (err) {
      console.error('🚨 LOGIN ERROR:', err);
      error = 'Email hoặc mật khẩu không đúng hoặc server không phản hồi.';
    } finally {
      isLoading = false;
    }
  }

  function loginGoogle() {
    window.location.href = 'http://localhost:3000/auth/google';
  }

  //$: console.log('init:', $user);
</script>

<div class="min-h-screen bg-gray-100 flex items-center justify-center px-4">
  <div class="bg-white shadow-xl rounded-xl p-8 w-full max-w-md">
    <h2 class="text-2xl font-bold text-gray-800 text-center mb-6">ĐĂNG NHẬP</h2>

    {#if error}
      <div class="bg-red-100 text-red-700 px-3 py-2 rounded mb-4 text-sm">
        {error}
      </div>
    {/if}

    <!-- Form login -->
    <form on:submit|preventDefault={loginLocal} class="space-y-5">
      <div>
        <label class="block text-sm font-medium text-gray-700">Email</label>
        <input
          type="email"
          class="mt-1 w-full px-4 py-2 border rounded-lg focus:ring focus:ring-blue-300 outline-none"
          bind:value={email}
          required />
      </div>

      <div>
        <label class="block text-sm font-medium text-gray-700">Mật khẩu</label>
        <input
          type="password"
          class="mt-1 w-full px-4 py-2 border rounded-lg focus:ring focus:ring-blue-300 outline-none"
          bind:value={password}
          required />
      </div>

      <button
        type="submit"
        class="w-full py-2 rounded-lg bg-blue-600 text-white font-semibold hover:bg-blue-700 transition flex justify-center"
        disabled={isLoading}>
        {#if isLoading}
          <svg
            class="animate-spin h-5 w-5 text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4l3-3-3-3v4a12 12 0 00-12 12h4z"></path>
          </svg>
        {:else}
          Đăng nhập
        {/if}
      </button>
    </form>

    <!-- Divider -->
    <div class="flex items-center my-6">
      <div class="flex-1 h-px bg-gray-300"></div>
      <span class="px-3 text-gray-500 text-sm">hoặc</span>
      <div class="flex-1 h-px bg-gray-300"></div>
    </div>

    <!-- Login Google -->
    <button
      on:click={loginGoogle}
      class="w-full py-2 border border-gray-300 rounded-lg flex items-center justify-center gap-2 hover:bg-gray-100 transition disabled:bg-gray-400 disabled:cursor-not-allowed"
      disabled={true}>
      <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" class="h-5 w-5" />
      <span>Đăng nhập với Google</span>
    </button>
  </div>
</div>
